import React from 'react';
import CategoryCard from '../components/CategoryCard';

export default function CategoriesSection({ groups, onSelect, totalGroups, onSeeAll }) {
  if (!groups || groups.length === 0) return null;

  return (
    <div style={styles.section}>
      <h2 style={styles.title}>Catégories analysées</h2>
      <div style={styles.list}>
        {groups.map((g) => (
          <CategoryCard key={g.category} group={g} onTap={onSelect} />
        ))}
      </div>
      {typeof totalGroups === 'number' && totalGroups > groups.length && (
        <button type="button" onClick={onSeeAll} style={styles.seeAll}>
          Voir toutes les catégories ({totalGroups})
        </button>
      )}
    </div>
  );
}

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  title: {
    margin: '0 0 4px',
    fontSize: 14,
    fontWeight: 700,
    color: '#6B6B6B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  seeAll: {
    marginTop: 4,
    background: 'transparent',
    border: 'none',
    color: '#E8502A',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    fontFamily: 'inherit',
    padding: 8,
  },
};
